// @ts-nocheck
/**
 * @param min
 * @param value
 * @param max
 */
export default function within(min, value, max) {
    return Math.max(min, Math.min(value, max));
}
//# sourceMappingURL=within.js.map